<template>
  <div class="app-main-content">
    <div class="main-content" style="overflow: auto;">
      <div v-show="!isPreview" :class="readonly ? 'not-click' : ''" style="width: fit-content">
        <div style="display: flex">
          <div v-for="block in blocks" :key="block.pagePart.pagePartName" class="section" style="width: 336px;">
            <el-form :disabled="readonly" label-width="140px" label-position="right" style="height: 100%;display: flex;flex-direction: column;">
              <el-form-item label=" ">
                <span class="element-column-text" :title="$t('SeaExport.Display')">{{ $t('SeaExport.Display') }}</span>
                <span class="element-column-text" :title="$t('SeaExport.Required')">{{ $t('SeaExport.Required') }}</span>
                <span class="element-column-text" :title="$t('SystemMaintenance.Alias')" style="width: 80px;">{{ $t('SystemMaintenance.Alias') }}</span>
                <span class="element-column-text" :title="$t('Tool.Setting')">{{ $t('Tool.Setting') }}</span>
              </el-form-item>
              <el-form-item v-for="element in (block.serialNumber === 1 ? firstBlockElements : block.uiCustomElementList)" :key="element.pagePartElement.elementName">
                <span slot="label" :class="element.isRequire ? 'blue' : ''">{{ element.sysLabel }}</span>
                <el-checkbox
                  v-model="element.isDisplay"
                  :disabled="!element.pagePartElement.displayCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || checkHqSetDisable(element)"
                  class="element-column-content"
                  @change="onDisplayChange(block, element)"
                />
                <el-checkbox
                  v-model="element.isRequire"
                  :disabled="!element.pagePartElement.requireCanCustom || (!!element.hqUICustomElement && element.hqUICustomElement.isRequire) || !element.isDisplay || checkHqSetDisable(element)"
                  class="element-column-content"
                />
                <span class="element-column-text" :title="element.customLabel" style="width: 80px;pointer-events: auto;">{{ element.customLabel }}</span>
                <span :class="'element-column-content' + (element.pagePartElement.aliasCanCustom && branchId === 1 && element.isDisplay ? '' : ' el-icon-edit-disabled')">
                  <i class="el-icon-edit" @click="onEditElementLabel(element)" />
                </span>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
      <!-- 预览 -->
      <cargo-ag-grid
        v-if="isPreview"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="[]"
      />
    </div>
    <!-- 元素设置弹窗 -->
    <element-set-dialog :visible.sync="elementSetDialog.visible" :element="elementSetDialog.element" />
  </div>
</template>

<script>
import gridTabScript from '@/views/cargo/v0/SystemMaintenance/components/pageUICustom/gridTabScript'
import { BookingWorkspaceContext } from '@/views/cargo/v0/SeaExport/components/booking/bookingWorkspaceContext'

export default {
  name: 'SeaBookingCharge',
  components: { gridTabScript },
  mixins: [gridTabScript],
  data() {
    return {
      bookingWorkspaceContext: new BookingWorkspaceContext(),
      blockWidth: 336 // 包含主票：391，不包含：336
    }
  },
  computed: {
    firstBlockElements() {
      if (this.blocks.length > 0) {
        if (this.addedElements && this.addedElements.length > 0) {
          const elements = this.blocks[0].uiCustomElementList
          const nameSet = new Set()
          for (const element of elements) {
            nameSet.add(element.pagePartElement.elementName)
          }
          for (const addedElement of this.addedElements) {
            if (!nameSet.has(addedElement.pagePartElement.elementName)) {
              elements.push(addedElement)
            }
          }
          elements.sort((a, b) => a.serialNumber - b.serialNumber)
        }
        return this.blocks[0].uiCustomElementList
      }
      return []
    },
    columnDefs() {
      const result = []
      for (const element of this.firstBlockElements) {
        if (element.isDisplay) {
          result.push({
            headerName: element.customLabel || element.sysLabel,
            field: element.pagePartElement.elementName
          })
        }
      }
      return result
    }
  },
  created() {
    this.bookingWorkspaceContext.prepareData()
  }
}
</script>

<style lang="scss" scoped>
@import "./base.scss";
</style>
